import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  milestoneItem: null,
  milestoneItems: [],
  milestoneLoading: false,
  milestonesLoading: false,
  milestonePagination: {},
  milestoneActionLoading: false, // create/update/delete loading
  error: "",
});

export default function milestoneReducer(state = initialState, action) {
  switch (action.type) {
    // GET MILESTONE ITEMS
    case ACTIONS.MILESTONE.PENDING: {
      return state.set("error", "").set("milestonesLoading", true);
    }
    case ACTIONS.MILESTONE.SUCCESS: {
      return state
        .set("error", "")
        .set("milestoneItems", action.data.data)
        .set("milestonePagination", action.data.pagination)
        .set("milestonesLoading", false);
    }
    case ACTIONS.MILESTONE.ERROR: {
      return state.set("milestonesLoading", false).set("error", action.error);
    }

    // GET MILESTONE DETAILS
    case ACTIONS.MILESTONE_DETAILS.PENDING: {
      return state.set("error", "").set("milestoneLoading", true);
    }
    case ACTIONS.MILESTONE_DETAILS.SUCCESS: {
      return state
        .set("milestoneLoading", false)
        .set("error", "")
        .set("milestoneItem", action.data);
    }
    case ACTIONS.MILESTONE_DETAILS.ERROR: {
      return state.set("milestoneLoading", false).set("error", action.error);
    }

    // UPDATE MILESTONE
    case ACTIONS.UPDATE_MILESTONE.PENDING: {
      return state.set("milestoneActionLoading", true).set("error", "");
    }
    case ACTIONS.UPDATE_MILESTONE.SUCCESS: {
      return state
          .set("error", "")
          .set("milestoneActionLoading", false);
    }
    case ACTIONS.UPDATE_MILESTONE.ERROR: {
      return state.set("error", action.error).set("milestoneActionLoading", false);
    }

    // CREATE MILESTONE
    case ACTIONS.CREATE_MILESTONE.PENDING: {
      return state.set("milestoneActionLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_MILESTONE.SUCCESS: {
      return state
        .set("milestoneActionLoading", false)
        .set("error", "");
    }
    case ACTIONS.CREATE_MILESTONE.ERROR: {
      return state.set("error", action.error).set("milestoneActionLoading", false);
    }

    // DELETE MILESTONE
    case ACTIONS.DELETE_MILESTONE.PENDING: {
      return state.set("milestoneActionLoading", true);
    }
    case ACTIONS.DELETE_MILESTONE.SUCCESS: {
      return state
        .set("error", "")
        .set("milestoneActionLoading", false);
    }
    case ACTIONS.DELETE_MILESTONE.ERROR: {
      return state.set("milestoneActionLoading", false).set("error", action.error);
    }

    // DELETE MILESTONE
    case ACTIONS.CLEAR_CURRENT_MILESTONE.SUCCESS: {
      return state.set("milestoneItem", null);
    }

    case ACTIONS.RESET_MILESTONE_ERRORS.SUCCESS: {
      return state.set("error", "");
    }


    default: {
      return state;
    }
  }
}
